import { RequestKind, string } from '@sb/library/base';
import { ApiRoute } from '../api-route';

export namespace HealthCheckRoutes {
    export const Get = ApiRoute.Define({
        URL: `health/`,
        Kind: RequestKind.Get,
        ResultType: string
    });
}
